import { getImageUrl } from "src/Common/common";
import { ActionMenu, ActionMenuIcon } from "src/Components/Common/ActionMenu";

const AssignedOptions = ({
  onEdit,
  onDuplicate,
  onUnassign,
  onClose,
  canEdit = true,
  canDuplicate = true,
  canUnassign = true,
}) => {
  return (
    <ActionMenu onClose={onClose}>
      {canEdit && (
        <ActionMenuIcon onClick={onEdit} title="Edit" src={getImageUrl("/images/common/edit.png")} />
      )}
      {canDuplicate && (
        <ActionMenuIcon
          onClick={onDuplicate}
          title="Duplicate"
          src={getImageUrl("/images/common/white_duplicate.png")}
        />
      )}
      {canUnassign && (
        <ActionMenuIcon
          onClick={onUnassign}
          title="Unassign"
          src={getImageUrl("/images/common/white_repeat.png")}
        />
      )}
    </ActionMenu>
  );
};

export default AssignedOptions;
